import script from "./UpsertRoleDrawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpsertRoleDrawer.vue?vue&type=script&lang=ts&setup=true"

import "./UpsertRoleDrawer.vue?vue&type=style&index=0&id=79853672&lang=scss"

const __exports__ = script;

export default __exports__